// src/polaris-components/RequireAdmin.tsx
import { Navigate, Outlet } from 'react-router-dom';
import { isAthlete } from '../utils/auth';
import { useAuth } from '../contexts/AuthContext';

export default function RequireAdmin() {
    const { isAuthenticated, isLoading } = useAuth();

    // Show loading state while checking authentication
    if (isLoading) {
        return <div>Loading...</div>;
    }

    // Check if user is authenticated
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    // Check if user is an athlete (not admin/staff)
    if (isAthlete()) {
        return <Navigate to="/athlete/profile" replace />;
    }

    // User is authenticated and is admin/staff
    return <Outlet />;
}

